<template>
  <v-container fluid grid-list-lg fill-height>
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 xl2>
        <v-card style="height: 100%; overflow: auto">
          <v-system-bar color="accent" dark window style="position: sticky; top: 0; z-index: 2">
            <v-toolbar-title>Алфавитный указатель</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="openForm(null)" v-if="accesses[`glossary-${this.type}_create`]" class="mx-0"><v-icon class="mx-0">add</v-icon></v-btn>
          </v-system-bar>
          <dantser-tree
            class="pa-2"
            :icon="false"
            ref="glossaryTree"
            :selectMode="1"
            :source="glossaryTree"
            @click-node="getGlossaryWord"
            @ctx-menu="openCtxMenu($event)"
          ></dantser-tree>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md8 lg9 xl10 style="overflow: scroll">
        <glossary-form v-if="dialog" v-bind="formProps" :type="type" @close-dialog="dialog=false" @save="saveChanges"></glossary-form>
        <v-card v-show="!dialog" style="height: 100%; overflow: auto; position: relative">
          <v-system-bar color="accent" dark window style="position: sticky; top: 0;">
            <v-toolbar-title>Определения</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field style="margin-right: -8px" solo-inverted flat single-line label="Поиск" v-model="search" hide-details
                          append-icon="search" @click:append="searchHelp" @keyup.enter="searchHelp"></v-text-field>
          </v-system-bar>
          <div class="pa-3" style="overflow:scroll" id="words-container">
            <template v-if="!showSearch">
              <div v-for="(block, index) in glossary" :key="index" :id="index">
                <h3 class="text-xs-center headline">{{index}}</h3>
                <div v-for="(word, idx) in block" :key="word.id" :id="word.id">
                  <h3 class="headline">{{word.word}}</h3>
                  <div v-for="(definition, dindex) in word.definitions" :key="dindex">
                    <p class="my-2"><i>{{definitionTypes[dindex]}}</i></p>
                    <ol class="ml-3">
                      <li v-for="item in definition" :key="item.id" v-html="item.text"></li>
                    </ol>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <h3 class="title mb-2 pl-2"><i>Результаты, найденные по запросу</i> : "{{searchText}}"</h3>
              <div v-for="(block, index) in searchResults" :key="index" :id="index">
                <h3 class="text-xs-center headline">{{index}}</h3>
                <div v-for="(word, idx) in block" :key="word.id" :id="word.id">
                  <h3 class="headline">{{word.word}}</h3>
                  <div v-for="(definition, dindex) in word.definitions" :key="dindex">
                    <p class="my-2"><i>{{definitionTypes[dindex]}}</i></p>
                    <ol class="ml-3">
                      <li v-for="item in definition" :key="item.id" v-html="item.text"></li>
                    </ol>
                  </div>
                </div>
              </div>
            </template>
            
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    
    <context-menu id="helper-context-menu" ref="ctxMenu">
      <li @click="openForm(currentElement)" v-if="accesses[`glossary-${this.type}_update`]"><v-icon small>mdi-pencil</v-icon> Редактировать</li>
      <li @click="deleteHelper(currentElement)" v-if="accesses[`glossary-${this.type}_delete`]"><v-icon small>delete</v-icon> Удалить</li>
    </context-menu>
  
  </v-container>
</template>

<script>
  import GlossaryForm from './Forms/GlossaryForm'
  import contextMenu from 'vue-context-menu'
  import {mapGetters} from 'vuex'
  
  export default {
    name : 'Glossary',
    
    components:{
      GlossaryForm,
      contextMenu
    },
    
    data() {
      return {
        search: '',
        searchText: '',
        searchResults: [],
        showSearch: false,
        type: 'system',
        dialog: false,
        formProps: {},
        helperElement: null,
        currentElement: null,
        definitionTypes: ['Дефиниция','Этимология','Идиома','Прочее']
      }
    },
  
    computed: {
      ...mapGetters('helper', ['glossary', 'glossaryTree']),
      accesses(){
        return this.$store.state.app.account.accesses['helper'] || {}
      },
    },
  
  
    mounted(){
      this.$store.commit("helper/setGlossaryTree", [])
      this.$store.commit("helper/setGlossary", [])
      this.type = this.$route.params.type
      this.getGlossaryTree()
      this.getWords()
    },
    
    beforeRouteUpdate (to, from, next) {
      this.$store.commit("helper/setGlossaryTree", [])
      this.$store.commit("helper/setGlossary", [])
      
      this.type = to.params.type
      this.getGlossaryTree()
      this.getWords()
      this.dialog = false
      next()
    },
    
    methods : {
      getGlossaryTree(){
        this.$store.dispatch("helper/getGlossaryTree", this.type)
      },
  
      getWords(){
        this.$store.dispatch("helper/getGlossary", {type: this.type, letter: 0})
      },
  
      getGlossaryWord(node){
        let element = document.getElementById(node.id)
        if(element){
          element.scrollIntoView({block: "start", behavior: "smooth"})
        }
      },
      
      openCtxMenu(eventData){
        if(eventData.data.id!==eventData.data.name && (this.accesses[`glossary-${this.type}_delete`] || this.accesses[`glossary-${this.type}_update`])){
          this.$refs.ctxMenu.open()
          this.currentElement = eventData.data
        }
      },
      
      deleteHelper(data){
        this.$root.$confirm('Удаление слова', 'Вы уверены, что хотите удалить данное слово?', {}).then( confirm => {
          this.$store.dispatch("helper/deleteWord", {type: this.type, id: data.id}).then( response => {
            this.$refs.glossaryTree.deleteNodeById(data.id)
            let letter = data.name[0]
            const index = this.glossary[letter].findIndex( el => el.id === data.id)
            if(index>-1) this.glossary[letter].splice(index, 1)
            if(this.glossary[letter].length === 0){
              this.$refs.glossaryTree.deleteNodeById(letter)
              delete this.glossary[letter]
            }
            this.$store.commit("helper/setGlossaryTree", this.glossaryTree)
            this.$store.commit("helper/setGlossary", this.glossary)
          })
        }).catch(()=>{})
      },
      
      openForm(data){
        if(data!==null){
          this.$store.dispatch("helper/getWord", {type: this.type, id: data.id}).then( word => {
            this.formProps = { editMode: true, data: word }
            this.dialog = true
          })
        } else {
          this.formProps = { editMode: false }
          this.dialog = true
        }
      },
  
      searchHelp(){
        if(this.search.length === 0){
          this.searchResults = []
          this.searchText = ''
          this.showSearch = false
        } else {
          this.$store.dispatch("helper/searchWord", {type: this.type, search: this.search}).then( data => {
            this.showSearch = true
            this.searchText = this.search
            this.searchResults = data
          })
        }
      },
      
      saveChanges(eventData){
        this.getGlossaryTree()
        this.getWords()
        this.dialog = false
      }
    }
  }
</script>

<style scoped>
  #helper-context-menu ul.ctx-menu li{
    padding: 5px 7px 5px 10px;
    cursor: pointer;
    font-size: 1rem;
  }
  #helper-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #helper-context-menu ul.ctx-menu li i{
    width: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/apps/help/components/Glossary/Glossary.vue